import React from "react";
import ImportInstructions from "../../../../components/dashboard/students/importStudent/ImportInstructions";

export default function () {
  return <ImportInstructions />;
}
